var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.extensionImg)?_c('div',{staticClass:"sideAdvertisingSpace_box",style:({top: _vm.setTop + 'px'}),on:{"click":_vm.toHotSeason}},[_c('img',{attrs:{"src":_vm.extensionImg,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('key1000604')))]),_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('key1000605')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }